import { Loggable, LoggableContext } from '../Loggable';
interface ChildReferenceContext extends LoggableContext {
    childCount: number;
}

export class ChildReferences<
    HTMLElementType extends HTMLElement
> extends Loggable {
    public childReferences: Array<HTMLElementType>;
    protected className = 'ChildReferences';
    constructor(public context: ChildReferenceContext) {
        super(context);
        this.childReferences = new Array(context.childCount);
    }
    getChildIndexListener = (index: number) => {
        return (childInstance: HTMLElementType | null) => {
            this.assignInstanceToChildIndex(childInstance, index);
        };
    };
    focusChild(index: number) {
        this.debug(`Processing Focus for ${index} on`, this.childReferences);
        if (this.childReferences && this.childReferences[index] !== undefined) {
            this.debug(`Focusing ${index}`, this.childReferences[index]);
            this.childReferences[index].focus();
        }
    }
    getPreviousChildIndex(index: number): number {
        this.debug(
            `Finding previous child of ${index} in`,
            this.childReferences
        );
        // TODO: findLastIndex can be used when browser support allows
        let childIndex = 0;
        for (
            let elementIndex = this.childReferences.length - 1;
            elementIndex >= 0;
            elementIndex--
        ) {
            if (
                elementIndex < index &&
                this.childReferences[elementIndex] !== undefined
            ) {
                childIndex = elementIndex;
                break;
            }
        }
        return childIndex;
    }
    getNextChildIndex(index: number): number {
        this.debug(`Finding next child of ${index} in`, this.childReferences);
        const childIndex = this.childReferences.findIndex(
            (elementRef, elementIndex) =>
                elementIndex > index && elementRef !== undefined
        );
        return childIndex;
    }
    updateChildCount = (length: number) => {
        this.debug(`updating child count to:`, length);
        this.childReferences.length = length;
    };
    private assignInstanceToChildIndex = (
        childInstance: HTMLElementType | null,
        childIndex: number
    ) => {
        this.debug(`assigning instance to ${childIndex}:`, childInstance);
        if (this.childReferences && this.childReferences.length > childIndex) {
            this.debug('assigned');
            this.childReferences[childIndex] = childInstance || undefined;
        }
    };
}



// WEBPACK FOOTER //
// ./src/utils/accessibility/ChildReferences.ts